import { render, staticRenderFns } from "./log-view.vue?vue&type=template&id=521724d1&scoped=true&"
import script from "./log-view.vue?vue&type=script&lang=js&"
export * from "./log-view.vue?vue&type=script&lang=js&"
import style0 from "./log-view.vue?vue&type=style&index=0&id=521724d1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521724d1",
  null
  
)

export default component.exports